import SectionV2 from './SectionV2'
export default SectionV2
